
export default {
  name: "CrmEmptyState",
  props: {
    description: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "la la-inbox",
    },
    title: {
      type: String,
      required: true,
    },
  },
};
